import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Mounts Lenis smooth inertia scroll — DESKTOP ONLY.
 * Mobile devices use native momentum scroll which is smoother than any JS
 * scroll-hijacker and doesn't flash/repaint on iOS Safari.
 */
function isTouchDevice() {
  if (typeof window === "undefined") return false;
  // Coarse pointer (touch), OR small screen, OR reduced-motion set
  if (window.matchMedia("(pointer: coarse)").matches) return true;
  if (window.matchMedia("(max-width: 1023px)").matches) return true;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
  // Old iOS / Android fallback
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}

export default function useSmoothScroll() {
  useEffect(() => {
    // Skip entirely on touch/mobile — native scroll is smoother there
    if (isTouchDevice()) return;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 1.0,
      touchMultiplier: 1.5,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}
